<template>
  <div class="card">
    <div class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>
    <div v-if="$slots.headerSVG">
        <slot name="headerSVG"></slot>
    </div>
    <div class="card-header" v-if="$slots.header">
        <slot name="header">
        </slot>
    </div>
    <div class="card-header" v-if="title">
      <slot name="header">
        <h3 class="card-title">{{title}}</h3>
        <p class="card-category" v-if="subTitle">{{subTitle}}</p>
      </slot>
    </div>
    <div class="card-body" v-if="$slots.default">
      <slot></slot>
    </div>
    <slot name="raw-content"></slot>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    title: String,
    subTitle: String
  }
};
</script>
<style>
</style>
